import { render, staticRenderFns } from "./aliplayer.vue?vue&type=template&id=20f04c8d&scoped=true&"
import script from "./aliplayer.vue?vue&type=script&lang=js&"
export * from "./aliplayer.vue?vue&type=script&lang=js&"
import style0 from "./aliplayer.vue?vue&type=style&index=0&id=20f04c8d&prod&lang=scss&scoped=true&"
import style1 from "./aliplayer.vue?vue&type=style&index=1&id=20f04c8d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f04c8d",
  null
  
)

export default component.exports